import { render } from "./AdminsEdit.vue?vue&type=template&id=dd3b42fe"
import script from "./AdminsEdit.vue?vue&type=script&lang=js"
export * from "./AdminsEdit.vue?vue&type=script&lang=js"

import "./AdminsEdit.vue?vue&type=style&index=0&id=dd3b42fe&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__